import { animationLoop, isSafari } from '../common/utils';
export function initTopParallax(modules, triggers) {
    if (isSafari()) {
        return;
    }
    modules.filter(function (m) { return m.name === 'TopParallax'; }).forEach(function (_a) {
        var el = _a.el;
        return initBg(el);
    });
    animationLoop.start();
    function initBg(root) {
        var speed = parseFloat(root.dataset.speed) || 0.5;
        animationLoop.subscribe(function () {
            root.style.transform = "translateY(".concat(window.pageYOffset * speed, "px)");
        });
    }
}
